import { render } from "./ShipStatus.vue?vue&type=template&id=74c55da9&scoped=true"
import script from "./ShipStatus.vue?vue&type=script&lang=js"
export * from "./ShipStatus.vue?vue&type=script&lang=js"

import "./ShipStatus.vue?vue&type=style&index=0&id=74c55da9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c55da9"]])

export default __exports__